import UserClassificationDetails from './UserClassificationDetails.container';
export default UserClassificationDetails;